import React from "react";
import { PostHogProvider } from "posthog-js/react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";

/* polyfills.js */
import "react-app-polyfill/ie11";
import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/number/is-nan";

import App from "./App";
const options = {
  api_host: window.config?.REACT_APP_PUBLIC_POSTHOG_HOST ?? "",
};
ReactDOM.render(
  <PostHogProvider
    apiKey={window.config?.REACT_APP_PUBLIC_POSTHOG_KEY ?? ""}
    options={options}
  >
    <Router>
      <App />
    </Router>
  </PostHogProvider>,
  document.getElementById("root")
);
